"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Content = exports.ContentComponent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Loader = _interopRequireDefault(require("../../../../../../components/Loader"));

var _NavMenuDivider = _interopRequireDefault(require("../../../NavMenuDivider"));

var _Product = _interopRequireDefault(require("../Product"));

var _apps = require("../../../../../../config/apps");

var _IntegratedExperience = require("./IntegratedExperience");

var _fetchProductsActivationInfo = require("../../../../../../api/fetch-products-activation-info");

var _links = require("../../links");

var _productsStatus = require("../../productsStatus");

var ContentContainer = function ContentContainer(_ref) {
  var currentProduct = _ref.currentProduct,
      environment = _ref.environment,
      features = _ref.features,
      inverted = _ref.inverted,
      onLinkClick = _ref.onLinkClick,
      onReloadHandler = _ref.onReloadHandler,
      swicusOrgId = _ref.swicusOrgId,
      onShowFeedbackModal = _ref.onShowFeedbackModal;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      hasIntegratedExperience = _useState4[0],
      setIntegratedExperience = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      productsStatusCallSuccess = _useState6[0],
      setProductsStatusCallSuccess = _useState6[1];

  var _useState7 = (0, _react.useState)((0, _productsStatus.generateInitialProductsStatus)(currentProduct)),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      productsStatus = _useState8[0],
      setProductsStatus = _useState8[1];

  var hasPingdomConvergence = features.pingdomConvergence;
  (0, _react.useEffect)(function () {
    if (swicusOrgId) {
      getProductsActivationInfo();
    } else {
      setLoading(false);
    }
  }, [swicusOrgId]);

  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
      active: true,
      inline: "centered"
    });
  }

  return /*#__PURE__*/_react["default"].createElement(ContentComponent, {
    currentProduct: currentProduct,
    environment: environment,
    features: features,
    hasIntegratedExperience: hasIntegratedExperience,
    inverted: inverted,
    onLinkClick: onLinkClick,
    onReloadHandler: onReloadHandler,
    products: (0, _apps.getProducts)(hasIntegratedExperience, hasPingdomConvergence),
    productsStatus: productsStatus,
    swicusOrgId: swicusOrgId,
    productsStatusCallSuccess: productsStatusCallSuccess,
    onShowFeedbackModal: onShowFeedbackModal
  });

  function getProductsActivationInfo() {
    return _getProductsActivationInfo.apply(this, arguments);
  }

  function _getProductsActivationInfo() {
    _getProductsActivationInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var info;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _fetchProductsActivationInfo.fetchProductsActivationInfo)(environment, swicusOrgId);

            case 3:
              info = _context.sent;
              setNewProductsStatus(info.products);
              setIntegratedExperience(info.hasCombinedNavigation);
              setProductsStatusCallSuccess(true);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              // eslint-disable-next-line no-console
              console.error(_context.t0);
              setNewProductsStatus((0, _productsStatus.generateStatusForAllProducts)(_productsStatus.PRODUCT_STATUS.CAN_SWITCH));

            case 13:
              setLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));
    return _getProductsActivationInfo.apply(this, arguments);
  }

  function setNewProductsStatus(productsStatus) {
    productsStatus[currentProduct] = _productsStatus.PRODUCT_STATUS.CURRENT_PRODUCT;
    setProductsStatus(productsStatus);
  }
};

var ContentComponent = function ContentComponent(_ref2) {
  var currentProduct = _ref2.currentProduct,
      environment = _ref2.environment,
      features = _ref2.features,
      hasIntegratedExperience = _ref2.hasIntegratedExperience,
      inverted = _ref2.inverted,
      _onLinkClick = _ref2.onLinkClick,
      onReloadHandler = _ref2.onReloadHandler,
      products = _ref2.products,
      productsStatus = _ref2.productsStatus,
      swicusOrgId = _ref2.swicusOrgId,
      productsStatusCallSuccess = _ref2.productsStatusCallSuccess,
      onShowFeedbackModal = _ref2.onShowFeedbackModal;
  var isIntegratedExperienceFeedbackEnabled = features && features.integratedExperienceFeedback;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, products.map(function (product) {
    var productStatus = productsStatus[product.id];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: product.id
    }, /*#__PURE__*/_react["default"].createElement(_Product["default"], (0, _extends2["default"])({}, product, {
      url: (0, _links.getLink)(currentProduct, environment, products, product.id, productsStatus, swicusOrgId),
      features: features,
      inverted: inverted,
      productStatus: productStatus,
      swicusOrgId: swicusOrgId,
      onLinkClick: function onLinkClick() {
        return _onLinkClick(product.id, productStatus);
      }
    })), /*#__PURE__*/_react["default"].createElement(_NavMenuDivider["default"], null));
  }), isIntegratedExperienceVisible() && /*#__PURE__*/_react["default"].createElement(_IntegratedExperience.IntegratedExperience, {
    environment: environment,
    hasIntegratedExperience: hasIntegratedExperience,
    onReloadHandler: onReloadHandler,
    currentProduct: currentProduct,
    onShowFeedbackModal: isIntegratedExperienceFeedbackEnabled ? onShowFeedbackModal : undefined,
    swicusOrgId: swicusOrgId
  }));

  function isIntegratedExperienceVisible() {
    return productsStatusCallSuccess && currentProduct !== 'papertrail';
  }
};

exports.ContentComponent = ContentComponent;
var Content = ContentContainer;
exports.Content = Content;